import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { API_CONFIG } from '../config/env';
import { QK_NOTICE_LIST } from '../query-keys';
import { Notice } from '../types';

const NOTICE_URL = API_CONFIG.NOTICE_URL;
const API_KEY = API_CONFIG.NOTICE_API_KEY;

export const useFetchNotice = () => {
  return useQuery<Notice[]>({
    queryKey: [QK_NOTICE_LIST],
    queryFn: async () => {
      const res = await axios.get(`${NOTICE_URL}?serviceType=SURVEY`, {
        headers: { 'x-api-key': API_KEY },
      });
      return res.data;
    },
  });
};
